/**
 * i18n
 *
 * @author Shigq
 * @date 2021/4/15 18:17
 */
import { plugins } from '@libs/ui'
import en from './lang/en'
import zh from './lang/zh-cn'

const LOCALE_ZH = 'zh-cn'
const LOCALE_EN = 'en'
const LOCALE_XHR_MAP = {
  [LOCALE_EN]: 'en_US',
  [LOCALE_ZH]: 'zh_CN'
}
const LOCALE_GEETEST_MAP = {
  [LOCALE_EN]: 'en-US',
  [LOCALE_ZH]: 'zh-CN'
}

const instance = plugins.i18n.getCurrentInstance({
  messages: {
    zh: zh,
    en: en
  }
})

const _useI18n = plugins.i18n.useI18n(instance)

/**
 * SR-LANG locale mapping
 * @type {{locale: *}}
 */
_useI18n.sr = (() => {
  return {
    locale: LOCALE_XHR_MAP[instance.global.locale]
  }
})()

/**
 * SR-LANG locale mapping
 * @type {{locale: *}}
 */
_useI18n.gt = (() => {
  return {
    locale: LOCALE_GEETEST_MAP[instance.global.locale]
  }
})()

export const useI18n = () => {
  return _useI18n
}

export default app => {
  plugins.i18n.install(app, instance)
  app.config.globalProperties.localCN = _useI18n.isLocal
}
